import * as Icon from "@ant-design/icons";
import { Modal, Row, Col, Form, Flex } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table";
import { useEffect } from "react";
import { AtivoModel } from "../../models/ativoModel";
import { BancoModel } from "../../models/banco/bancoModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarBancoAtivo, buscarBanco, deletarBanco } from "../../services/bancoService";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import CadastroEdicaoBanco from "./modals/cadastrar";
import { ButtonComponent } from "../../components/button/cadastrar";
import MensagemModal from "../../components/modal/mensagem";
import { setBuscaBanco, setEntityBanco, setModalCadastrarBanco, setModalDeletarBanco } from "../../redux/slices/banco/bancoSlice";
import TableComponent from "../../components/table/tableComponent";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { SwitchComponent } from "../../components/button/switch";

const Banco = () => {
  //estados globais
  const bancoState = useAppSelector((state) => state.banco);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(bancoState.entity).length != 0;

  useEffect(() => {
    dispatch(setTitle("BANCOS"));
    dispatch(buscarBanco(bancoState.busca));
    form.setFieldsValue({
      pesquisar: bancoState.busca,
    });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityBanco({}));
    dispatch(setModalCadastrarBanco(true));
  };

  const goEditar = (value: BancoModel) => {
    dispatch(setEntityBanco(value));
    dispatch(setModalCadastrarBanco(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarBanco(false));
  };

  const goDeletar = (value: BancoModel) => {
    dispatch(setEntityBanco(value));
    dispatch(setModalDeletarBanco(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarBanco(false));
  };

  const onChangeAtivo = (value: BancoModel) => {
    let args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarBancoAtivo({ value: args, busca: bancoState.busca }));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaBanco(value));
    dispatch(buscarBanco(value));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<BancoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ABREVIATURA",
      dataIndex: "abreviatura",
      sorter: (a, b) => a.abreviatura.localeCompare(b.abreviatura),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "CÓDIGO",
      dataIndex: "codigoBanco",
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      width: 100,
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent checked={record.ativo} onChange={() => onChangeAtivo(record)} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominação ou Abreviatura" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={bancoState.list} columns={columns} loading={bancoState.loading} />
      <Modal title={editar ? "EDITAR BANCO" : "NOVO BANCO"} centered width={1150} open={bancoState.modalCadastrar} onCancel={closeModalCadastrar} footer={null} destroyOnHidden>
        <CadastroEdicaoBanco />
      </Modal>
      <Modal title={"REMOVER BANCO"} centered width={350} open={bancoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text="Deseja remover o banco?" action={deletarBanco({ value: bancoState.entity.id, busca: bancoState.busca })} close={setModalDeletarBanco(false)} />
      </Modal>
    </Flex>
  );
};

export default Banco;
